package horcrux.frontend.common.views.collections

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.configs.StaticContentConfigs
import horcrux.frontend.common.views.collections.editcollectionmenu.EditPrivateCollectionMenu
import horcrux.frontend.common.views.collections.editcollectionmenu.EditPublicCollectionMenu
import horcrux.frontend.common.views.collections.navigator.PrivateCollectionSelector
import horcrux.frontend.common.views.collections.navigator.SingletonCollectionSelector
import horcrux.frontend.common.views.components.containers.HStack
import horcrux.frontend.common.views.components.input.InstructionsWithHelp
import horcrux.frontend.common.views.components.loading.LoadingIcon
import mui.system.sx
import react.FC
import react.Props
import react.dom.html.ReactHTML.h1
import web.cssom.pt

external interface CollectionSelectorAndMenuProps : Props {
    var globalAppState: GlobalAppState
    var chatWithYourCollection: String
}

val CollectionSelectorAndMenu = FC<CollectionSelectorAndMenuProps> { props ->
    val width = 500.pt
    props.globalAppState.chatPageDataMaybeState.get()?.let { chatPageData ->
        InstructionsWithHelp {
            this.id = "collection-navigator-instructions"
            this.instructions = "This is a Public Chat Page"
            this.helpText =
                """This is a public chat page. Another user created this page from their private collection. It contains the collection documents, its chat history, along with any sources The Grok App used to respond to queries. You can pick up where they left off by using the chat window below.""".trimIndent()
            this.textTagSupplierMaybe = { h1 }
            this.sx {
                this.marginTop = StaticContentConfigs.APP_BAR_HEIGHT
            }
        }
        HStack {
            SingletonCollectionSelector {
                this.globalAppState = props.globalAppState
                this.collectionMetadata = chatPageData.chatPageMetadata.collectionMetadata
                this.sx {
                    this.width = width
                }
            }
            EditPublicCollectionMenu {
                this.globalAppState = props.globalAppState
            }
        }
    } ?: run {
        InstructionsWithHelp {
            this.id = "collection-navigator-instructions"
            this.instructions = "Collection Navigator"
            this.helpText =
                """This is the collection navigator. A collection is a group of documents which you want to learn about. Create a collection and import documents to get started. Click "${props.chatWithYourCollection}" when you're ready to learn more about it.""".trimIndent()
            this.textTagSupplierMaybe = { h1 }
            this.sx {
                this.marginTop = StaticContentConfigs.APP_BAR_HEIGHT
            }
        }
        HStack {
            PrivateCollectionSelector {
                this.globalAppState = props.globalAppState
                this.sx {
                    this.width = width
                }
            }
            EditPrivateCollectionMenu {
                this.globalAppState = props.globalAppState
            }
            LoadingIcon {
                this.onClick = { isLoadingState ->
                    if (!isLoadingState.get()) {
                        props.globalAppState.updateCollectionsMetadataByID {
                            isLoadingState.setFalse()
                        }
                    }
                }
            }
        }
    }
}
